import { IncidentControlService } from './incident-control.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastsManager } from 'ng2-toastr';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Logger } from 'angular2-logger/core';
import { UserService } from '../user/user.service';

declare var jquery: any;
declare var $: any;
@Component({
    selector: 'app-incident-control',
    templateUrl: './incident-control.component.html',
    styleUrls: ['./incident-control.component.scss'],
    providers: [IncidentControlService, UserService]
})
export class IncidentControlComponent implements OnInit {

    @ViewChild('modalDetails')
    public modalDetails: ModalDirective;

    @ViewChild('modalCreate')
    public modalCreate: ModalDirective;

    public list: any;
    public details_user: any;
    //public load: boolean;
    //public load_init: boolean;
    public incidentForm: FormGroup;
    public pag_size: number;
    public pag_number: number;
    public total_items: number;
    public itemQuantity: any;
    public user_id: any;
    @ViewChild('contacts_pag') contacts_pag: ElementRef;
    @ViewChild('contacts_num') contacts_num: ElementRef;

    public dataExcel: any = [];

    constructor(
        public _incidentService: IncidentControlService,
        private fb: FormBuilder,
        public _shared: SharedService,
        private spinner: NgxSpinnerService,
        private logger: Logger,
        private userService: UserService,
        public toastr: ToastsManager) {

        let data = {
            auth_token: this._shared.getCookie("auth_token")
        };

        this._shared.getCurrent(data).subscribe(
            data => {
                if (data.status) {
                    this.user_id = data.data.id;
                } else {
                    this.logger.log(data.message); // Que no tengo permisos. 
                }
            },
            error => {
                this.logger.log(error);

            }
        );

    }

    ngAfterViewInit() {

        $(this.contacts_pag.nativeElement).on('change', (e) => {
            this.pag_size = e.target.value;
            this.pag_number = 1;
            this.getListIncident();
        });

        $(this.contacts_num.nativeElement).on('change', (e) => {
            this.pag_number = e.target.value;
            this.getListIncident();
        });

    }

    ngOnInit() {
        //this.load_init = true;
        this.spinner.show();
        this.pag_size = 10;
        this.pag_number = 1;
        this.getListIncident();
        this.incidentForm = this.fb.group({
            description: ['', Validators.required],
            incident_severity_id: ['', Validators.required],
            incident_control_id: ['', Validators.required],
        });
    }


    getListIncident() {
        //this.load_init = true;
        this.spinner.show();
        let data = {
            auth_token: this._shared.getCookie('auth_token'),
            limit: this.pag_size,
            page: this.pag_number
        };

        this._incidentService.getIncidentData(data).subscribe(
            data => {
                this.list = data.data.data;

                for (let i in data.data.data) {
                    let tempExcel = [];
                        tempExcel['Descripción']          = data.data.data[i].description;
                        tempExcel['Severidad del incidente']   = data.data.data[i].name_severity;
                        tempExcel['Estado del incidente'] = data.data.data[i].name_incident;
                        tempExcel['Usuario']          = data.data.data[i].firstname + ' ' + data.data.data[i].lastname;
        
                    this.dataExcel.push(tempExcel);
                }

                this.total_items = data.data.total;
                this.itemQuantity = Array(data.data.last_page).fill(0).map((x, i) => i + 1);
                //this.load_init = false;
                this.spinner.hide();
            }, error => {
                this.toastr.error("Ocurrió un error al consultar las incidencias", "Error");
            });
    }

    onDetails(details: any) {
        this.spinner.show();
        this.details_user = details;
        //$('#DetailsUser').modal('toggle');
        this.modalDetails.show();
        this.spinner.hide();
    }



    createIncidentModal() {
        this.modalCreate.show();
        //$('#CreateIncident').modal('toggle');
    }

    createIncident() {
        let user = '';
        if (this._shared.activateBlockSupervisor().agent_id) {
            user = this._shared.activateBlockSupervisor().agent_id;
        } else {
            user = this.user_id;
        }

        this.spinner.show();
        let data = {
            description: this.incidentForm.value.description,
            incident_severity_id: this.incidentForm.value.incident_severity_id,
            incident_control_id: this.incidentForm.value.incident_control_id,
            user_id: user
        };

        console.log(data);

        this._incidentService.insertIncidentDetails(data).subscribe(
            data => {
                console.log(data);
                this.toastr.success("Se ha registrado la incidencia correctamente", "Exito");
                this.getListIncident();
                this.modalCreate.hide();
            }, error => {
                this.toastr.error("Ocurrió un error al registrar la incidencia", "Error");
                this.modalCreate.hide();
            });
    }

    exportAsXLSX(): void {
        this.userService.exportAsExcelFile(this.dataExcel, 'reporte');
    }


}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/incident-control/incident-control.component.ts